import { __awaiter, __generator } from "tslib";
var AbstractAdapter = /** @class */ (function () {
    function AbstractAdapter(config) {
        this.requestDecorator = config.requestDecorator || (function (request) { return request; });
    }
    AbstractAdapter.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._record(this.requestDecorator(request), request)];
            });
        });
    };
    return AbstractAdapter;
}());
export default AbstractAdapter;
//# sourceMappingURL=AbstractAdapter.js.map